const PRODUCT_IMAGE_FALLBACKS: Record<string, string[]> = {
  zipper: ["zipper.png", "zipper-hinten.png"],
  "schlauchschaal-mit-logo": ["schlauchschaal.png", "schlauchschaal-hinten.png"],
};

export const resolveShopImageSrc = (imageSrc: string): string => {
  if (!imageSrc) {
    return "";
  }

  if (imageSrc.startsWith("/") || imageSrc.startsWith("http")) {
    return imageSrc;
  }

  try {
    return require(`../../../assets/images/shop/${imageSrc}`);
  } catch {
    return imageSrc;
  }
};

export const getProductImagesWithFallback = (productSlug: string, imageUrls: string[]): string[] => {
  const normalizedImages = imageUrls.length > 0 ? imageUrls : [""];
  const fallbackImages = PRODUCT_IMAGE_FALLBACKS[productSlug];

  if (
    fallbackImages &&
    normalizedImages.every((imageUrl) => !imageUrl || imageUrl.includes("product-placeholder.svg"))
  ) {
    return fallbackImages;
  }

  return normalizedImages;
};
